import AppConfig from "../AppConfig.json";
export const appConfig = AppConfig;
